import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getBranchPermission,
  getParticularPage,
  getNext,
  getPrevious,
  createBranchPermission,
  updateBranchPermission,
  handleSearch,
} from "./thunk";

const initialState = {
  branchPermissions: [],
  edit: false,
  branchPermission: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingBranchPermission: false,
  loadingNext: false,
  showCreateModal: false,
};

export const branchPermissionSlice = createSlice({
  name: "branchPermission",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    branchPermissionEditSuccess: (state, action) => {
      state.edit = true;
      state.branchPermission = state.branchPermissions.find(
        (branchPermission) => branchPermission.id === action.payload
      );
    },
    clearAllPermission: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingBranchPermission = false;
      state.branchPermission = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBranchPermission.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createBranchPermission.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createBranchPermission.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateBranchPermission.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateBranchPermission.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateBranchPermission.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getBranchPermission.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingBranchPermission = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBranchPermission.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingBranchPermission = false;
        state.branchPermissions = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBranchPermission.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingBranchPermission = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, branchPermissionEditSuccess, clearAllPermission } =
  branchPermissionSlice.actions;

export default branchPermissionSlice.reducer;
